import { combineReducers } from "redux";
import {
  COHORT_REQUEST_MENTOR_DASHBOARD,
  DASHBOARD_MENTOR_MYREQUEST,
  DASHBOARD_MENTOR_HOME,
  MENTORSHIP_APPLICATION,
  MENTORSHIP_STARTUP_APPLICATION,
  MENTORSHIP_STARTUP_APPLICATION_STATUS,
  VIEW_COUNTER_MENTOR_OPTIONS,
  SESSIONS_MENTOR_SUMMARY_POST_DATA,  
  POST_MENTOR_FEEDBACK,
  GET_MENTOR_FEEDBACK,
  MENTOR_COHORT_APPLICATION_LIST,
  MENTOR_MODULE_COHORT_LIST,
  MENTOR_MODULE_STARTUP_COHORT_LIST,
  MENTOR_MODULE_STARTUP_COHORT_STATUS,
  MENTOR_MODULE_MENTOR_COHORT_STATUS,
  MENTOR_MODULE_STARTUP_COHORT_COUNTER,
  MENTOR_MODULE_MENTOR_COHORT_COUNTER,
  MATCH_COHORT_LIST,
  MATCH_STARTUP_LIST,
  MATCH_MENTOR_LIST,
  MATCH_COHORT_REQUEST,
  MATCH_RESULT_LIST,
  CREATE_COHORT_GROUP_SESSION,
  DELETE_COHORT_GROUP_SESSION,
  DETAILS_COHORT_GROUP_SESSION,
  LIST_COHORT_GROUP_SESSION,
  LIST_SESSION_MEMBER_LIST,
  GROUP_SESSION_CHANGE_STATUS,
  LIST_COHORT_GROUP_SESSION_COUNTER,
  COHORT_SESSION_INVITATION_LIST,
  COHORT_SESSION_GIVE_FEEDBACK,
  COHORT_SESSION_VIEW_FEEDBACK,
  COHORT_SESSION_NOTES_GIVE_FEEDBACK,
  COHORT_SESSION_NOTES_VIEW_FEEDBACK,
  COHORT_GROUP_SESSION_HOURS,
  COHORT_GROUP_SESSION_HOURS_FILTER,
  POST_COHORT_PROGRAM_SPOTLIGHT,
  COHORTS_COMMON_DASHBOARD,
  COHORTS_DISCUSSION_LIST,
  COHORTS_DISCUSSION_POST,
  COHORTS_DISCUSSION_POST_COMMENT,
  COHORTS_DISCUSSION_COMMENT_LIST,
  COHORTS_DISCUSSION_POST_LIKE,
  COHORTS_COMMENT_POST_LIKE,
  COHORTS_DISCUSSION_POST_UNLIKE,
  COHORTS_COMMENT_POST_UNLIKE,
  COHORTS_THREAD_REMOVE_POST,
  COHORTS_COMMENT_REMOVE_POST,
  COHORTS_COMMENT_REPLY_LIST,
  COHORTS_COMMENT_REPLY_POST,
  COHORT_DASHBOARD_ACTIVITY,
  COHORT_DASHBOARD_STARTUP_COUNTER,
  COHORT_DASHBOARD_MENTORS_COUNTER,
} from "../../../../common/constants/actionConstants";

const getCohortForMentorList = (state = [], action) => {
  switch (action.type) {
    case COHORT_REQUEST_MENTOR_DASHBOARD:
      return { ...action.payload };
    default:
      return state;
  }
};

const DashboardMentorMyRequestList = (state = [], action) => {
  switch (action.type) {
    case DASHBOARD_MENTOR_MYREQUEST:
      return { ...action.payload };
    default:
      return state;
  }
};

const DashboardMentorHomeList = (state = [], action) => {
  switch (action.type) {
    case DASHBOARD_MENTOR_HOME:
      return { ...action.payload };
    default:
      return state;
  }
};
const MentorApplicationStatus = (state = [], action) => {
  switch (action.type) {
    case MENTORSHIP_APPLICATION:
      return { ...action.payload };
    default:
      return state;
  }
};
const MentorApplicationList = (state = [], action) => {
  switch (action.type) {
    case MENTORSHIP_STARTUP_APPLICATION:
      return { ...action.payload };
    default:
      return state;
  }
};
const MentorSessionMinutes = (state = [], action) => {
  switch (action.type) {
    case SESSIONS_MENTOR_SUMMARY_POST_DATA:
      return { ...action.payload };
    default:
      return state;
  }
};
const MentorApplicationListStatus = (state = [], action) => {
  switch (action.type) {
    case MENTORSHIP_STARTUP_APPLICATION_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getCountersMentorList = (state = [], action) => {
  
  switch (action.type) {
    case VIEW_COUNTER_MENTOR_OPTIONS:
      return { ...action.payload };
    default:
      return state;
  }
};
const postMentorFeedback = (state=[] , action) => {
  switch (action.type) {
    case POST_MENTOR_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const getMentorFeedback = (state=[] , action) => {
  switch (action.type) {
    case GET_MENTOR_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const getCohortMentorList = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_COHORT_APPLICATION_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const getCohortMentorModuleList = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_MODULE_COHORT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const setCohortMentorStatus = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_MODULE_MENTOR_COHORT_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const setCohortStatusStatus = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_MODULE_STARTUP_COHORT_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const getStartupCohortMentorModuleList = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_MODULE_STARTUP_COHORT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};const getMentorCohortMentorModuleCounter = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_MODULE_MENTOR_COHORT_COUNTER:
      return { ...action.payload };
    default:
      return state;
  }
};const getStartupCohortMentorModuleCounter = (state=[] , action) => {
  switch (action.type) {
    case MENTOR_MODULE_STARTUP_COHORT_COUNTER:
      return { ...action.payload };
    default:
      return state;
  }
};

const getCohortMatchTable = (state=[] , action) => {
  switch (action.type) {
    case MATCH_COHORT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const getMatchStartupList = (state=[] , action) => {
  switch (action.type) {
    case MATCH_STARTUP_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const getMatchMentorList = (state=[] , action) => {
  switch (action.type) {
    case MATCH_MENTOR_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const getMatchMakingRequest = (state=[] , action) => {
  switch (action.type) {
    case MATCH_COHORT_REQUEST:
      return { ...action.payload };
    default:
      return state;
  }
};
const getMatchMakingResult = (state=[] , action) => {
  switch (action.type) {
    case MATCH_RESULT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const createCohortGroupSession = (state=[] , action) => {
  switch (action.type) {
    case CREATE_COHORT_GROUP_SESSION:
      return { ...action.payload };
    default:
      return state;
  }
};
const deleteCohortGroupSession = (state=[] , action) => {
  switch (action.type) {
    case DELETE_COHORT_GROUP_SESSION:
      return { ...action.payload };
    default:
      return state;
  }
};
const detailsCohortGroupSession = (state=[] , action) => {
  switch (action.type) {
    case DETAILS_COHORT_GROUP_SESSION:
      return { ...action.payload };
    default:
      return state;
  }
};
const listCohortGroupSession = (state=[] , action) => {
  switch (action.type) {
    case LIST_COHORT_GROUP_SESSION:
      return { ...action.payload };
    default:
      return state;
  }
};
const listSessionMemberList = (state=[] , action) => {
  switch (action.type) {
    case LIST_SESSION_MEMBER_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const groupSessionChangeStatus = (state=[] , action) => {
  switch (action.type) {
    case GROUP_SESSION_CHANGE_STATUS:
      return { ...action.payload };
    default:
      return state;
  }
};
const listCohortGroupSessionCounters = (state=[] , action) => {
  switch (action.type) {
    case LIST_COHORT_GROUP_SESSION_COUNTER:
      return { ...action.payload };
    default:
      return state;
  }
};
const listCohortInvitation = (state=[] , action) => {
  switch (action.type) {
    case COHORT_SESSION_INVITATION_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortGiveFeedBack = (state=[] , action) => {
  switch (action.type) {
    case COHORT_SESSION_GIVE_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortViewFeedBack = (state=[] , action) => {
  switch (action.type) {
    case COHORT_SESSION_VIEW_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortSessionNotesViewFeedBack = (state=[] , action) => {
  switch (action.type) {
    case COHORT_SESSION_NOTES_VIEW_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortSessionNotesGiveFeedBack = (state=[] , action) => {
  switch (action.type) {
    case COHORT_SESSION_NOTES_GIVE_FEEDBACK:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortGroupSessionHours = (state=[] , action) => {
  switch (action.type) {
    case COHORT_GROUP_SESSION_HOURS:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortGroupSessionHoursFilter = (state=[] , action) => {
  switch (action.type) {
    case COHORT_GROUP_SESSION_HOURS_FILTER:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortProgramSpotLight = (state=[] , action) => {
  switch (action.type) {
    case POST_COHORT_PROGRAM_SPOTLIGHT:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortCommonList = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_COMMON_DASHBOARD:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortGetDiscussionList= (state=[] , action) => {
  switch (action.type) {
    case COHORTS_DISCUSSION_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortPostDiscussionThread = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_DISCUSSION_POST:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortGetDiscussionCommentList= (state=[] , action) => {
  switch (action.type) {
    case COHORTS_DISCUSSION_COMMENT_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortPostThreadComment = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_DISCUSSION_POST_COMMENT:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortPostThreadLikeToggle= (state=[] , action) => {
  switch (action.type) {
    case COHORTS_DISCUSSION_POST_LIKE:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortPostCommentLikeToggle = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_COMMENT_POST_LIKE:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortPostThreadUnLikeToggle= (state=[] , action) => {
  switch (action.type) {
    case COHORTS_DISCUSSION_POST_UNLIKE:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortPostCommentUnLikeToggle = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_COMMENT_POST_UNLIKE:
      return { ...action.payload };
    default:
      return state;
  }
};

const cohortThreadRemove = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_THREAD_REMOVE_POST:
      return { ...action.payload };
    default:
      return state;
  }
};


const cohortCommentRemove = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_COMMENT_REMOVE_POST:
      return { ...action.payload };
    default:
      return state;
  }
};


const cohortCommentReplyPost = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_COMMENT_REPLY_POST:
      return { ...action.payload };
    default:
      return state;
  }
};


const cohortCommentReplyList = (state=[] , action) => {
  switch (action.type) {
    case COHORTS_COMMENT_REPLY_LIST:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortDashboardActivity = (state=[] , action) => {
  switch (action.type) {
    case COHORT_DASHBOARD_ACTIVITY:
      return { ...action.payload };
    default:
      return state;
  }
};

const cohortDashboardMentorCounter = (state=[] , action) => {
  switch (action.type) {
    case COHORT_DASHBOARD_MENTORS_COUNTER:
      return { ...action.payload };
    default:
      return state;
  }
};
const cohortDashboardStartupCounter= (state=[] , action) => {
  switch (action.type) {
    case COHORT_DASHBOARD_STARTUP_COUNTER:
      return { ...action.payload };
    default:
      return state;
  }
};

const MentorReducer = combineReducers({
  getCohortForMentorList,
  DashboardMentorMyRequestList,
  DashboardMentorHomeList,
  MentorApplicationStatus,
  MentorApplicationListStatus,
  MentorApplicationList,
  getCountersMentorList,
  MentorSessionMinutes,
  postMentorFeedback,
  getMentorFeedback,
  getCohortMentorList,
  getCohortMentorModuleList,
  getStartupCohortMentorModuleList,
  setCohortMentorStatus,
  setCohortStatusStatus,
  getMentorCohortMentorModuleCounter,
  getStartupCohortMentorModuleCounter,
  getCohortMatchTable,
  getMatchStartupList,
  getMatchMentorList,
  getMatchMakingRequest,
  getMatchMakingResult,
  createCohortGroupSession,
  deleteCohortGroupSession,
  detailsCohortGroupSession,
  listCohortGroupSession,
  listSessionMemberList,
  groupSessionChangeStatus,
  listCohortGroupSessionCounters,
  listCohortInvitation,
  cohortGiveFeedBack,
  cohortViewFeedBack,
  cohortSessionNotesViewFeedBack,
  cohortSessionNotesGiveFeedBack,
  cohortGroupSessionHours,
  cohortGroupSessionHoursFilter,
  cohortProgramSpotLight,
  cohortCommonList,
  cohortGetDiscussionList,
  cohortPostDiscussionThread,
  cohortGetDiscussionCommentList,
  cohortPostThreadComment,
  cohortPostCommentLikeToggle,
  cohortPostThreadLikeToggle,
  cohortPostThreadUnLikeToggle,
  cohortPostCommentUnLikeToggle,
  cohortThreadRemove,
  cohortCommentRemove,
  cohortCommentReplyPost,
  cohortCommentReplyList,
  cohortDashboardActivity,
  cohortDashboardMentorCounter,
  cohortDashboardStartupCounter,
});

export default MentorReducer;